// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2qDc-","title":"Header_title__28mUW","left":"Header_left__1CsmB","clinicName":"Header_clinicName__2eZt2"};